import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAlertMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  input: Types.UpdateAlertInput;
}>;

export type UpdateAlertMutation = {
  __typename?: 'Mutation';
  updateAlert: {
    __typename?: 'Alert';
    id: any;
    name: string;
    description?: string | null;
    status: Types.AlertStatus;
    triggerCount: number;
    lastTriggeredAt?: any | null;
    createdAt: any;
    updatedAt: any;
  };
};

export const UpdateAlertDocument = gql`
  mutation UpdateAlert($id: UUID!, $input: UpdateAlertInput!) {
    updateAlert(id: $id, input: $input) {
      id
      name
      description
      status
      triggerCount
      lastTriggeredAt
      createdAt
      updatedAt
    }
  }
`;
export type UpdateAlertMutationFn = Apollo.MutationFunction<
  UpdateAlertMutation,
  UpdateAlertMutationVariables
>;

/**
 * __useUpdateAlertMutation__
 *
 * To run a mutation, you first call `useUpdateAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertMutation, { data, loading, error }] = useUpdateAlertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlertMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAlertMutation,
    UpdateAlertMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAlertMutation, UpdateAlertMutationVariables>(
    UpdateAlertDocument,
    options,
  );
}
export type UpdateAlertMutationHookResult = ReturnType<
  typeof useUpdateAlertMutation
>;
export type UpdateAlertMutationResult =
  Apollo.MutationResult<UpdateAlertMutation>;
export type UpdateAlertMutationOptions = Apollo.BaseMutationOptions<
  UpdateAlertMutation,
  UpdateAlertMutationVariables
>;
